import { render } from "./CommunitySale.vue?vue&type=template&id=0be266bc&scoped=true"
import script from "./CommunitySale.vue?vue&type=script&lang=js"
export * from "./CommunitySale.vue?vue&type=script&lang=js"

import "./CommunitySale.vue?vue&type=style&index=0&id=0be266bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be266bc"]])

export default __exports__